import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Gift, ShieldCheck } from 'lucide-react';
export function PricingCTA() {
  return <section id="comprar" className="py-24 bg-sage/10 relative" data-id="element-194">
      <div className="max-w-4xl mx-auto px-6" data-id="element-195">
        <FadeIn className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-sage/20 relative overflow-hidden" data-id="element-196">
          <div className="absolute top-0 right-0 w-64 h-64 bg-sage/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-197"></div>

          <div className="relative z-10 text-center mb-10" data-id="element-198">
            <h2 className="text-3xl md:text-5xl font-heading text-warm-dark mb-4" data-id="element-199">
              Comienza a liberar tu espalda
            </h2>
            <p className="text-lg text-warm-dark/70" data-id="element-200">
              Descarga inmediata. Lee a tu ritmo, desde cualquier dispositivo.
            </p>
          </div>

          <div className="flex flex-col md:flex-row gap-12 items-center justify-center mb-10" data-id="element-201">
            <div className="text-center" data-id="element-202">
              <span className="text-xl text-warm-dark/40 line-through font-heading" data-id="element-203">
                $19.99 USD
              </span>
              <span className="text-5xl font-heading font-bold text-warm-dark block mt-1" data-id="element-204">
                $6.39 USD
              </span>
              <p className="text-sm text-warm-dark/50 mt-2 uppercase tracking-wider" data-id="element-205">
                Pago único
              </p>
            </div>

            <div className="hidden md:block w-px h-24 bg-warm-alt" data-id="element-206"></div>

            <div className="space-y-4 text-left" data-id="element-207">
              <h4 className="font-medium text-warm-dark flex items-center gap-2" data-id="element-208">
                <Gift className="w-5 h-5 text-warm-accent" data-id="element-209" />
                Bonos Incluidos Hoy:
              </h4>
              <ul className="space-y-2 text-sm text-warm-dark/80" data-id="element-210">
                <li data-id="element-211">✓ Checklist de hábitos diarios</li>
                <li data-id="element-212">✓ Guía rápida de posturas de descanso</li>
                <li data-id="element-213">✓ Audio de relajación guiada (10 min)</li>
              </ul>
            </div>
          </div>

          <div className="text-center space-y-6" data-id="element-214">
            <Button href="https://pausaviva.com/cart/47287315398805:1" className="w-full md:w-auto px-12 py-5 text-xl shadow-lg shadow-sage/30" data-id="element-215">
              Comprar Ebook Ahora
            </Button>

            <div className="flex items-center justify-center gap-2 text-sm text-warm-dark/60" data-id="element-216">
              <ShieldCheck className="w-4 h-4" data-id="element-217" />
              <span data-id="element-218">Pago 100% seguro. Acceso inmediato.</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}